import { MODES_OF_APT, RECEIPT_PAYMENT_MODE_ID } from "@elixir/types";
import { create } from "zustand";
import { CreateAptStore } from "./types";

const useCreateAptStore = create<CreateAptStore>((set, get) => ({
  mode: MODES_OF_APT.IN_CLINIC,
  setMode: (mode) => set({ mode }),

  selectedDoctor: undefined,
  setSelectedDoctor: (doctor) => set({ selectedDoctor: doctor }),

  selectedClinic: undefined,
  setSelectedClinic: (clinicId) => set({ selectedClinic: clinicId }),

  selectedPatient: undefined,
  setSelectedPatient: (patient) =>
    set({ selectedPatient: patient, patientSearchTerm: "" }),

  selectedTags: [],
  setSelectedTags: ({ tagId }) => {
    const { selectedTags: currSelectedTags } = get();
    const tagIndex = currSelectedTags.indexOf(tagId);
    let tagsToReturn: Array<number> = [];
    if (tagIndex > -1) {
      tagsToReturn = [
        ...currSelectedTags.slice(0, tagIndex),
        ...currSelectedTags.slice(tagIndex + 1),
      ];
    } else {
      tagsToReturn = [...currSelectedTags, tagId];
    }
    set({
      selectedTags: tagsToReturn,
    });
  },
  setAllTags: (tags) => {
    set({
      selectedTags: tags,
    });
  },

  selectedSku: undefined,
  setSelectedSku: (sku) => set({ selectedSku: sku }),

  clearCreateAptStore: () => {
    set({
      selectedPatient: undefined,
      selectedSku: undefined,
      selectedTags: [],
      selectedInclusionIds: [],
      paymentPaymode: RECEIPT_PAYMENT_MODE_ID.CASH,
      mode: MODES_OF_APT.IN_CLINIC,
    });
  },
  paymentPaymode: RECEIPT_PAYMENT_MODE_ID.CASH,
  setPaymentPaymode: (paymentPaymode) => set({ paymentPaymode }),
  showSelectSlot: false,
  setShowSelectSlot: (status) => set({ showSelectSlot: status }),
  patientSearchTerm: "",
  setPatientSearchTerm: (term) => {
    set({ patientSearchTerm: term });
  },
  selectedInclusionIds: [],
  setSelectedInclusionIds: (ids) => {
    set({
      selectedInclusionIds: ids,
    });
  },
}));

export default useCreateAptStore;
